'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIList from 'UIComponents/list/UIList';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import styled from '../../utils/Styling';
const QuestionTitle = styled.span.withConfig({
  displayName: "QuestionAnswerList__QuestionTitle",
  componentId: "abk7ka-0"
})(["font-weight:500;"]);

const QuestionAnswerList = ({
  answers,
  disabled,
  multipleSelection,
  selectedAnswerIds,
  onSelectAnswer
}) => /*#__PURE__*/_jsx(UIList, {
  childClassName: "m-bottom-2",
  "data-test-id": "question-answer-list",
  children: answers.map(answer => {
    const answerId = answer.id;
    return /*#__PURE__*/_jsx(UISelectableButton, {
      block: true,
      "data-test-id": "quiz-radio-option",
      disabled: disabled,
      name: "quiz-options",
      onClick: (...partialArgs) => onSelectAnswer(answerId, ...partialArgs),
      selected: selectedAnswerIds.includes(answerId),
      style: {
        userSelect: 'inherit'
      },
      title: /*#__PURE__*/_jsx(QuestionTitle, {
        children: answer.text
      }),
      truncatable: false,
      type: multipleSelection ? 'checkbox' : 'radio'
    }, answerId);
  })
});

QuestionAnswerList.propTypes = {
  answers: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  multipleSelection: PropTypes.bool,
  onSelectAnswer: PropTypes.func.isRequired,
  selectedAnswerIds: PropTypes.array.isRequired
};
QuestionAnswerList.defaultProps = {
  disabled: false
};
export default QuestionAnswerList;